import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bom-pagination-selector',
  templateUrl: './pagination-selector.component.html',
  styleUrls: ['./pagination-selector.component.scss'],
})
export class PaginationSelectorComponent {
  @Input()
  total: number;

  @Input()
  paginationStart: number;

  @Input()
  paginationEnd: number;

  @Input()
  isLoading = false;

  @Output()
  nextPageClicked = new EventEmitter<any>();

  @Output()
  prevPageClicked = new EventEmitter<any>();
}
